export const environment = {
  production: true,
  apiUrl: 'https://testapi.unifersa.net/api',
  imagenUrl: 'https://testapi.unifersa.net/api/Fichero/obtener?id=',
  
  codigoAecoc: 'gyOWdqW7t4L5OeI5CxYmlPvawWfzRTDKnlvx7L8jRBQUGKqaMdPIsw==',
  apiKeyAecoc: 'ZGZhZTUwM2UtNTdjMi00YWNlLThmYjktMzVhZWFhOTUzNDdi',
};
